'use client';

export function ThreeMomentStory() {
  const auditPackVideo = process.env.NEXT_PUBLIC_AUDIT_PACK_VIDEO_URL;
  const hasVideo = Boolean(auditPackVideo);

  // If there is no video, do not render this section at all.
  if (!hasVideo) {
    return null;
  }

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4">
            See Scopax in action
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Generate the audit-ready pack in under a minute—evidence, dates, and change history in one download.
          </p>
        </div>

        <div className="max-w-5xl mx-auto mb-10">
          <div className="overflow-hidden rounded-2xl border bg-muted/20 shadow-sm">
            <video
              className="w-full h-full"
              src={auditPackVideo}
              controls
              playsInline
              preload="metadata"
            >
              Your browser does not support the video tag.
            </video>
          </div>
        </div>

        <div className="text-center">
          <a
            href="/api/demo/audit-pack"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold rounded-lg border-2 bg-background hover:bg-muted/50 transition-all shadow-sm"
          >
            Download sample Audit Pack (PDF)
          </a>
          <p className="text-xs text-muted-foreground mt-3">
            See exactly what auditors receive
          </p>
        </div>
      </div>
    </section>
  );
}
